// blackHoleGenerator.js
var BlackHoleGenerator = pc.createScript('blackHoleGenerator');

BlackHoleGenerator.attributes.add('bnry', {type: 'boolean', default: false, title: 'binarySystem'});
BlackHoleGenerator.attributes.add('sun', {type: 'entity', title: 'sunIfBinary'});
BlackHoleGenerator.attributes.add('acd1', {type:'entity', title: 'accretionDisk1'});
BlackHoleGenerator.attributes.add('acd2', {type:'entity', title: 'accretionDisk2'});
BlackHoleGenerator.attributes.add('glw', {type:'entity', title: 'glow'});
BlackHoleGenerator.attributes.add('heGlw', {type:'entity', title: 'highEnergyGlow'});
BlackHoleGenerator.attributes.add('mps', {type: 'asset', assetType: 'texture', array: true, title: 'accretionDust'});
BlackHoleGenerator.attributes.add('clr', {type: 'curve', color: 'rgba', title: 'colorGraph'});
BlackHoleGenerator.attributes.add('part', {type: 'entity', array: true, title: 'particleSystems'});
BlackHoleGenerator.attributes.add('crna', {type: 'entity', title: 'corona'});
BlackHoleGenerator.attributes.add('coronaMaps', {type: 'asset', assetType: 'texture', array: true, title: 'coronaMaps'});
BlackHoleGenerator.attributes.add('jUp', {type: 'entity', title: 'jetUp'});
BlackHoleGenerator.attributes.add('jDown', {type: 'entity', title: 'jDown'});
BlackHoleGenerator.attributes.add('xrayBinary', {type:'boolean', default:false, title:'XrayBinary'});

// initialize code called once per entity
BlackHoleGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    
    this.clrPick = new pc.Vec3();
    this.r = 0; this.g = 0; this.b = 0;
    this.bColor = null;
    this.acdmap1 = this.acd1.model.model.meshInstances[0].material;
    this.acdmap2 = this.acd2.model.meshInstances[0].material;
    this.glowMap = this.glw.model.meshInstances[0].material;
    this.heGlowMap = this.heGlw.model.model.meshInstances[0].material;
    this.corona = this.crna.model.meshInstances[0].material;
    if(this.bnry){
        this.sunScript = this.sun.script.sunGenerator;
    }
    this.jetRnd = 0;
    this.app.on('seeder:reset', this.reseed, this);
        this.generateBlackHole();
};

BlackHoleGenerator.prototype.reseed = function() {
    this.theSeed = this.seedScript.seed;
        this.generateBlackHole();
};


BlackHoleGenerator.prototype.generateBlackHole = function(){
    
    //this.initialize();
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    this.jetRnd = this.randomize();
    this.clrPick = this.randomize();
    this.scl = 1 + this.randomize();
    
    var rnd = Math.floor(this.randomize() * (this.mps.length-1));
    var cRnd = Math.floor(this.randomize() * (this.coronaMaps.length-1));
    var dustmap = this.mps[rnd].resource;
    var coronamap = this.coronaMaps[cRnd].resource;
   // console.log('DUSTMAP: ' + dustmap.name);
    this.r = this.clr.get(0).value(this.clrPick);
    this.g = this.clr.get(1).value(this.clrPick);
    this.b = this.clr.get(2).value(this.clrPick);
    
    if(this.bnry){

     this.bColor = this.sunScript.baseColor;
    } else{
       this.bColor = new pc.Color(this.r,this.g,this.b);
    }
      
    for(var plist = 0; plist < this.part.length; plist++){
        this.part[plist].particlesystem.colorGraph.curves[0].keys[1][1] = this.bColor.r;
        this.part[plist].particlesystem.colorGraph.curves[1].keys[1][1] = this.bColor.g;
        this.part[plist].particlesystem.colorGraph.curves[2].keys[1][1] = this.bColor.b;
        if(plist === 0 || plist == 2){
            this.part[plist].particlesystem.colorMap = dustmap;
        }
        this.part[plist].particlesystem.rebuild();
    }


    this.acdmap1.emissive = this.bColor;
    this.acdmap1.diffuseMap = dustmap;
    this.acdmap1.emissiveMap = dustmap;
    this.acdmap2.emissive = this.bColor;
    this.acdmap2.emissiveMap = dustmap;
    this.acdmap2.diffuseMap = dustmap;

    this.heGlowMap.emissive = this.bColor;
    this.glowMap.emissive = this.bColor;
    this.corona.emissive = this.bColor;
    this.corona.opacityMap = coronamap;
    
    this.acdmap1.update();
    this.acdmap2.update();
    this.glowMap.update();
    this.corona.update();
    this.heGlowMap.update();
    
    if (this.bnry) {
        this.acd1.enabled = true;
        this.acd2.enabled = true;
        if (this.jetRnd < 0.25) {
            this.jUp.enabled = false;
            this.jDown.enabled = false;
        } else if (this.jetRnd > 0.25 && this.jetRnd < 0.5) {
            this.jUp.enabled = true;
            this.jDown.enabled = false;
        } else if (this.jetRnd > 0.5 && this.jetRnd < 0.75) {
            this.jUp.enabled = false;
            this.jDown.enabled = true;
        } else if (this.jetRnd > 0.75) {
            this.jUp.enabled = true;
            this.jDown.enabled = true;
        }
    } else {
        this.acd1.enabled = false;
        this.acd2.enabled = false; 
        this.jUp.enabled = false;
        this.jDown.enabled = false;
    }
    
    this.entity.setLocalScale(this.scl, this.scl, this.scl);
    
};

// update code called every frame
BlackHoleGenerator.prototype.update = function(dt) {
//     if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {

//     }
};

// swap method called for script hot-reloading
// inherit your script state here
// BlachHoleGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

